// extracted by mini-css-extract-plugin
export var container = "banner-module--container--009df";
export var content = "banner-module--content--9bc76";
export var heading = "banner-module--heading--a2c46";
export var subtitle = "banner-module--subtitle--00ff0";